import { BreachPathGraphIconWebComponent } from './component/BreachPathGraphIconWebComponent';

export { BreachPathGraphIconWebComponent };
